import { Link } from "react-router-dom";
import { StarField } from "@/components/StarField";
import { Logo } from "@/components/Logo";

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#080B1A] via-[#0E1229] to-[#12102B] flex items-center justify-center relative px-4 py-12">
      <StarField count={70} />
      <div className="relative z-10 w-full max-w-md">
        <div className="flex justify-center mb-8">
          <Link to="/"><Logo textClass="text-2xl" iconSize={26} /></Link>
        </div>
        <div className="glass rounded-3xl p-8 shadow-2xl">
          <h1 className="font-serif text-3xl text-slate-50 text-center">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-slate-400 text-center">{subtitle}</p>}
          <div className="mt-7">{children}</div>
        </div>
        {footer && <div className="mt-6 text-center text-sm text-slate-400">{footer}</div>}
      </div>
    </div>
  );
}

export function Field({ label, error, children }) {
  return (
    <div>
      <label className="block text-xs uppercase tracking-[0.15em] text-amber-400/90 mb-1.5">{label}</label>
      {children}
      {error && <p className="mt-1 text-xs text-red-400">{error}</p>}
    </div>
  );
}

export const inputClass =
  "w-full rounded-xl bg-[#0B1024] border border-amber-500/20 px-4 py-3 text-sm text-slate-100 placeholder-slate-500 focus:outline-none focus:border-amber-400/60 focus:ring-1 focus:ring-amber-400/30 transition";
